"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconNavigatorHeader = void 0;
var React = require("react");
var PluginTemplates_1 = require("./PluginTemplates");
var FalconNavigatorHeader = /** @class */ (function (_super) {
    __extends(FalconNavigatorHeader, _super);
    function FalconNavigatorHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultBackButtonLabel = "Back";
        _this.pluginTemplates = new PluginTemplates_1.PluginTemplates();
        return _this;
    }
    FalconNavigatorHeader.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            this.renderBack(),
            this.renderTitle(),
            this.props.children);
    };
    FalconNavigatorHeader.prototype.renderTitle = function () {
        if (!this.props.title) {
            return undefined;
        }
        switch (typeof this.props.title) {
            case "string":
                return this.renderStringTitle(this.props.title);
            default:
                return this.renderObjectTitle(this.props.title);
        }
    };
    FalconNavigatorHeader.prototype.renderBack = function () {
        if (!this.props.back) {
            return undefined;
        }
        switch (typeof this.props.back) {
            case "string":
                return this.renderStringBack(this.props.back);
            default:
                return this.renderObjectBack(this.props.back);
        }
    };
    FalconNavigatorHeader.prototype.renderStringTitle = function (title) {
        if (!title) {
            return undefined;
        }
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-group title plugin no-indent-desktop" },
                React.createElement("h1", { className: this.props.children ? "mb-2" : "m-0" }, title)));
    };
    FalconNavigatorHeader.prototype.renderObjectTitle = function (titleProps) {
        if (titleProps.hidden || (!titleProps.label && !titleProps.html)) {
            return undefined;
        }
        if (titleProps.html) {
            return titleProps.html;
        }
        return this.renderStringTitle(titleProps.label);
    };
    FalconNavigatorHeader.prototype.renderStringBack = function (link) {
        return this.pluginTemplates.renderBackLink(this.defaultBackButtonLabel, true, link);
    };
    FalconNavigatorHeader.prototype.renderObjectBack = function (backProps) {
        var _a;
        if (backProps.hidden || (!backProps.link && !backProps.html && !backProps.action)) {
            return undefined;
        }
        if (backProps.html) {
            return backProps.html;
        }
        if (!backProps.action) {
            return this
                .pluginTemplates
                .renderBackLink((_a = backProps.label) !== null && _a !== void 0 ? _a : this.defaultBackButtonLabel, true, backProps.link);
        }
        else {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "back-link-top" },
                    React.createElement("a", { onClick: this.pluginTemplates.goBack },
                        React.createElement("button", { type: "button", role: "link", className: "btn btn-back-link", onClick: backProps.action }, "Back"))));
        }
    };
    return FalconNavigatorHeader;
}(React.Component));
exports.FalconNavigatorHeader = FalconNavigatorHeader;
//# sourceMappingURL=FalconNavigatorHeader.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/components/FalconNavigatorHeader.js
// module id = 2521
// module chunks = 0